/**
 * auth.ts - Authentication and Role Utilities
 * 
 * Shared utilities for role-based authentication
 */

export type Role = 'super-admin' | 'admin' | 'preparer' | 'deliverer' | 'editor' | 'read-only';
export type Permission = 'dashboard' | 'vendors' | 'users' | 'events' | 'orders' | 'analytics';

/**
 * Format role for display
 */
export const formatRole = (role: string): string => {
  switch (role) {
    case 'super-admin': return 'Super Admin';
    case 'admin': return 'Admin';
    case 'editor': return 'Editor';
    case 'read-only': return 'Read Only';
    case 'preparer': return 'Preparer';
    case 'deliverer': return 'Deliverer';
    default: return role;
  }
};
